module.exports = __webpack_public_path__ + "static/img/goldentoad_th.6fb8af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/goldentoad_th.png
// module id = TPVD
// module chunks = 1